import { useResendVerificationEmailMutation } from 'generated/rbi-graphql';
import { useFlag } from 'state/launchdarkly';
import { useLogger } from 'state/logger';
import { platform, welcomeEmailDomain } from 'utils/environment';
import { LaunchDarklyFlag } from 'utils/launchdarkly';

const useUserVerification = () => {
  const logger = useLogger();
  const enableGatewayResend = useFlag(LaunchDarklyFlag.ENABLE_GATEWAY_RESEND_VERIFICATION_EMAIL);
  const [resendVerificationEmail, { loading }] = useResendVerificationEmailMutation();
  const sendVerificationEmail = async () => {
    try {
      await resendVerificationEmail({
        variables: {
          input: {
            stage: welcomeEmailDomain(),
            platform: platform(),
          },
          gatewayEnabled: enableGatewayResend,
        },
      });
    } catch (error) {
      logger.error({ error, message: 'Failed to resend verification link' });
    }
  };
  return {
    loading,
    sendVerificationEmail,
  };
};

export default useUserVerification;
